module.exports = __webpack_public_path__ + "media/film.a7b7a6a4.mp4";